<template>
  <div class="flex flex-col w-full overflow-hidden">
    <div class="w-full h-full flex-grow overflow-y-auto" @scroll="handleScroll">
      <div class="w-full max-w-content mx-auto">
        <div class="h-10" ref="spacer"></div>
        <base-back-button />
        <template v-if="isRenovate">
          <div>
            <div class="px-4 sm:px-0">
              <h2 class="font-sans text-2xl uppercase mb-1" ref="pageTitle">Duplicado de carné social</h2>
              <p class="text-neutral">Estado del trámite</p>
              <div class="h-10"></div>
              <div class="flex items-center space-x-3 leading-1 mb-4 bg-green-50 text-slate-700 p-4 rounded-lg shadow border-green-300 border-2">
                <img src="@/assets/img/check.svg" />
                <p>El trámite de renovación <strong>ha sido procesado con éxito</strong> y se ha recibido el pago. Podrá acudir a recoger el carnet por oficinas generales en un plazo de dos días.</p>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="px-4 sm:px-0">
            <h2 class="font-sans text-2xl uppercase mb-1" ref="pageTitle">{{ pageTitle }}</h2>
            <h3 class="text-neutral mb-2">
              El duplicado del carné tiene un coste de {{ priceWithImage | money }}, puede facilitar una nueva fotografía
              o mantener la actual.
            </h3>
            <div class="leading-1 mb-4">
              <p>Puede subir una imágen que tenga almacenada o realizar la fotografía con nuestro sistema de captura, usando la cámara del equipo en el que se encuentra.</p>
            </div>
          </div>
          <div class="h-4"></div>
          <div class="px-4 sm:px-0">
            <h4 class="font-bold text-xl mb-2">Seleccione una opción</h4>
            <ul class="bg-white shadow rounded-lg divide-y mb-8 overflow-hidden">
              <li class="p-4">
                <div>
                  <el-radio v-model="option" label="new" @change="onChangeOptions">Subir fotografía</el-radio>
                </div>
                <div class="mt-4" v-if="option === 'new'">
                  <p class="text-sm text-slate-700">Su rostro ha de ser <strong>perfectamente identificable</strong>. Evite usar fotografías donde aparezca en compañía de otras personas, llevando gafas de sol, gorro, mascarilla o cualquier otra prenda que dificulte su reconocimiento.</p>
                  <p class="mt-4">
                    <input
                      type="file"
                      accept="image/jpeg"
                      class="file:flex file:flex-col file:mb-3 file:bg-secondary file:font-semibold file:border-none hover:file:bg-secondary-500 file:mr-4 file:px-4 file:py-2 file:text-sm file:rounded-lg file:text-white"
                      @change="onChangeFile"
                    />
                  </p>
                  <div class="pt-4 flex justify-end">
                    <base-button mode="primary" text="Renovar" @click="renovate" :disabled="!isValid" :loading="loading" />
                  </div>
                </div>
              </li>
              <li class="p-4">
                <div>
                  <el-radio v-model="option" label="take">Tomar fotografía</el-radio>
                </div>
                <div class="mt-4" v-if="option === 'take'">
                  <p class="text-sm text-slate-700">Antes de empezar le recordamos que es necesario que el dispositivo que vaya a usar para tomar la fotografía <strong>disponga de una cámara</strong> y se encuentre en un entorno con <strong>buenas condiciones de iluminación</strong>.</p>
                  <div class="pt-4 flex justify-end">
                    <base-button mode="primary" text="Tomar foto" @click="takeImage" />
                  </div>
                </div>
              </li>
              <li class="p-4">
                <div>
                  <el-radio v-model="option" label="current">Fotografía actual</el-radio>
                </div>
                <div class="mt-4" v-if="option === 'current'">
                  <div class="flex items-center justify-center space-x-3 shadow p-2 rounded-lg border border-slate-200">
                    <base-avatar :src="profileImage" :letter="firstLetterName" :zoom="true" @click="zoomModal = true" />
                    <p class="text-sm text-slate-700">Se renovará su tarjeta usando la fotografía de la que dispone actualmente.</p>
                  </div>
                  <div class="pt-4 flex justify-end">
                    <base-button mode="primary" text="Renovar" @click="renovate" />
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </template>
      </div>
    </div>
    <photo-modal :active.sync="photoModal" @image="onImage" />

    <base-modal v-model="zoomModal" :show-close="true">
      <el-image :src="profileImage" alt="Socio del grupo" fit="cover" />
    </base-modal>
  </div>
</template>

<script>
import { handleScrollMixin } from '@/mixins/appMixin'
import PhotoModal from '@/components/PhotoModal.vue'
import ImageWrapper from '@/utils/Image'
import CardServices from '@/services/cards'
import TpvServices from '@/services/tpv'

export default {
  name: 'MembershipCardRenewal',
  mixins: [handleScrollMixin],
  components: { PhotoModal },
  data: function () {
    return {
      option: 'new',
      image: null,
      loading: false,
      photoModal: false,
      zoomModal: false,
      prices: [],
      isRenovate: false
    }
  },
  computed: {
    pageTitle: function () {
      return this.$route?.meta?.title
    },
    maxImageHeight: function () {
      return parseFloat(process.env.VUE_APP_PROFILE_MAX_HEIGHT) || 500
    },
    isValid: function () {
      if (this.option === 'new') {
        return !!this.image
      }
      return false
    },
    membership: function () {
      return this.$store.getters['auth/membership']
    },
    profileImage: function () {
      return this.$store.getters['auth/image']
    },
    firstLetterName: function () {
      return this.$store.getters['auth/firstLetterName']
    },
    code: function () {
      if (this.option === 'current') {
        return 'CA03'
      }
      return 'CA01'
    },
    price: function () {
      return this.prices.find(p => p.CodConcepto === this.code)?.PrecioVenta || null
    },
    priceWithImage: function () {
      return this.prices.find(p => p.CodConcepto === 'CA01')?.PrecioVenta || null
    },
    priceWithoutImage: function () {
      return this.prices.find(p => p.CodConcepto === 'CA03')?.PrecioVenta || null
    }
  },
  created: function () {
    if (this.$route.query.purchase === 'ok') {
      this.isRenovate = true
    }
    if (this.$route.query.purchase === 'ko') {
      this.doFeedback('El proceso de pago no ha finalizado correctamente')
    }
    this.fetchPrices()
  },
  methods: {
    fetchPrices: async function () {
      try {
        this.$store.commit('app/setLoading', true)
        this.prices = await CardServices.getPrices()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    closeModal: function () {
      this.photoModal = false
    },
    openModal: function () {
      this.photoModal = true
    },
    onChangeOptions: function () {
      this.image = null
    },
    onChangeFile: async function (event) {
      this.loading = true
      if (event?.target?.files?.length) {
        try {
          const file = event.target.files[0]
          const img = new ImageWrapper(file, { maxSize: this.maxImageSize })
          const resize = await img.resize()
          this.image = resize
        } catch (error) {
          this.doFeedback('Se ha producido un error con la imagen')
        }
      } else {
        this.image = null
      }
      this.loading = false
    },
    takeImage: function () {
      this.openModal()
    },
    onImage: async function (image) {
      this.closeModal()
      const res = await fetch(image)
      const blob = await res.blob()
      const file = new File([blob], 'profile.jpg', { type: 'image/jpeg' })
      const img = new ImageWrapper(file, { maxHeight: this.maxImageHeight })
      const resize = await img.resize()
      this.image = ImageWrapper.removeMimeFromBase64(resize)
      this.renovate()
    },
    renovate: async function () {
      try {
        if (this.price) {
          if (this.option === 'current') {
            const id = await CardServices.renovate(this.membership)
            await this.purchase(this.membership, this.code, id, this.price)
          } else {
            const id = await CardServices.renovate(this.membership, this.image)
            await this.purchase(this.membership, this.code, id, this.price)
          }
        }
      } catch (error) {
        this.doFeedback()
      }
    },
    purchase: async function (membership, code, id, price) {
      const okUrl = process.env.VUE_APP_CARD_PURCHASE_REDIRECT_URI_OK
      const koUrl = process.env.VUE_APP_CARD_PURCHASE_REDIRECT_URI_KO

      const response = await TpvServices.setup(membership, code, id, price, okUrl, koUrl)
      const data = {
        MerchantID: response.merchantID,
        AcquirerBIN: response.acquirerBIN,
        TerminalID: response.terminalID,
        Num_operacion: response.operationNumber,
        Importe: response.price,
        TipoMoneda: response.currency,
        Exponente: response.exponent,
        URL_OK: response.urlOk,
        URL_NOK: response.urlNok,
        Firma: response.signature,
        Cifrado: response.cypher,
        Pago_soportado: response.supportedPayment
      }

      const form = document.createElement('form')
      form.method = 'post'
      form.action = response.action
      for (const key in data) {
        if (Object.hasOwnProperty.call(data, key)) {
          const hiddenField = document.createElement('input')
          hiddenField.type = 'hidden'
          hiddenField.name = key
          hiddenField.value = data[key]

          form.appendChild(hiddenField)
        }
      }

      document.body.appendChild(form)
      form.submit()
    }
  }
}
</script>

<style lang="css" scoped>
</style>
